import React from 'react';
import { Building2, Heart as Heartbeat, ShieldCheck, Truck, Store, Factory, Briefcase, DollarSign, ArrowRight } from 'lucide-react';

const industries = [
  {
    icon: Heartbeat,
    title: 'Healthcare',
    description: 'Revolutionize patient care with AI-driven diagnostics and workflow optimization.',
  },
  {
    icon: Store,
    title: 'Retail',
    description: 'Transform customer experiences with predictive analytics and smart inventory management.',
  },
  {
    icon: ShieldCheck,
    title: 'Insurance',
    description: 'Streamline claims processing and enhance risk assessment with intelligent automation.',
  },
  {
    icon: DollarSign,
    title: 'Fintech',
    description: 'Innovate financial services with AI-powered fraud detection and personalized banking.',
  },
  {
    icon: Factory,
    title: 'Manufacturing',
    description: 'Optimize production and maintenance with IoT integration and predictive analytics.',
  },
  {
    icon: Truck,
    title: 'Logistics',
    description: 'Enhance supply chain efficiency with real-time tracking and route optimization.',
  },
  {
    icon: Building2,
    title: 'Real Estate',
    description: 'Transform property management with smart building solutions and predictive maintenance.',
  },
  {
    icon: Briefcase,
    title: 'Professional Services',
    description: 'Elevate service delivery with intelligent workflow automation and resource optimization.',
  },
];

const Industries = () => {
  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 fade-in-up">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            AI-Led Solutions Across Industries
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Delivering transformative AI and automation solutions tailored to your industry's unique challenges.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="bg-black/50 backdrop-blur-sm rounded-xl p-6 hover:shadow-xl 
                transition-all duration-300 transform hover:-translate-y-1
                border border-gray-800/50 hover:bg-black/70 card-hover fade-in-up"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-teal-500/10 rounded-xl flex items-center justify-center">
                    <industry.icon size={24} className="text-teal-400" />
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2">{industry.title}</h3>
                  <p className="text-gray-400">{industry.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* New CTA after Industries */}
        <div className="cta-container">
          <a href="/case-studies" className="btn-secondary">See Industry-Specific Case Studies</a>
        </div>
      </div>
    </section>
  );
};

export default Industries;